@if (!isHandset) {
  <div class="session-page" (window:resize)="onResize($event)">
    <div class="session-titles">
      <div class="session-titles-header">
        <h3>Menu Propriétaire</h3>
        <!-- <button matButton mat-button (click)="showMenu = !showMenu;"><mat-icon>+</mat-icon></button> -->
      </div>
      <div class="session-titles-content" >
        <h5>Dashboard</h5>
        <h6><a routerLink ="/owner/dashboard">Dashboard</a> </h6>
        <mat-divider></mat-divider>
        <h5>Parc</h5>
        <h6><a [routerLink]="['/owner/park']">Voir mes voitures</a></h6>
        <h6><a [routerLink]="['/owner/post-new-car']">Poster une voiture</a></h6>
        <mat-divider></mat-divider>
        <h5>Ventes</h5>
        <h6><a [routerLink]="['/owner/buy']">Ventes en cours </a></h6>
        <h6><a [routerLink]="['/owner/buy']">Ventes conclues</a></h6>
        <mat-divider></mat-divider>
        <h5>Locations</h5>
        <h6><a [routerLink]="['/owner/rent']">Réservations</a></h6>
        <h6><a [routerLink]="['/owner/rent']">Locations en cours</a></h6>
        <h6><a [routerLink]="['/owner/rent']">Locations conclues</a></h6>
        <mat-divider></mat-divider>
        <h5>Communication</h5>
        <h6><a [routerLink]="['/owner/appointments']">Mes rendez-vous </a></h6>
        <h6><a [routerLink]="['/owner/conversations']">Mes conversations</a></h6>
        <h6><a [routerLink]="['/owner/notifications']">Notifications </a></h6>
        <mat-divider></mat-divider>
        <h5>Compte</h5>
        <h6><a [routerLink]="['/owner/my-providers']">Mes fournisseurs </a></h6>
        <h6><a [routerLink]="['/owner/contracts']">Mes contrats</a></h6>
        <h6><a [routerLink]="['/owner/account']">Mon profil</a></h6>
        <h6><a [routerLink]="['/provider']">Mon compte provider </a></h6>
      </div>
    </div>
    <div class="session-content">
      <router-outlet></router-outlet>
      @if ((fetchingResults$ | async)!) {
        <p style="text-align:center">
          <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
        </p>
      }
    </div>
  </div>
}


@if (isHandset) {
  <div class="session-page" (window:resize)="onResize($event)" >
    <mat-drawer-container class="sidenav-container" autosize>
      <mat-drawer #drawer class="sidenav-menu" mode="over" position="end">
        <div class="session-titles-header">
          <h3>Menu Propriétaire &nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <h5>Dashboard</h5>
        <h6><a routerLink ="/owner/dashboard">Dashboard</a> </h6>
        <mat-divider></mat-divider>
        <h5>Parc</h5>
        <h6><a [routerLink]="['/owner/park']">Voir mes voitures</a></h6>
        <h6><a [routerLink]="['/owner/post-new-car']">Poster une voiture</a></h6>
        <mat-divider></mat-divider>
        <h5>Ventes</h5>
        <h6><a [routerLink]="['/owner/buy']">Ventes en cours </a></h6>
        <h6><a [routerLink]="['/owner/buy']">Ventes conclues</a></h6>
        <mat-divider></mat-divider>
        <h5>Locations</h5>
        <h6><a [routerLink]="['/owner/rent']">Réservations</a></h6>
        <h6><a [routerLink]="['/owner/rent']">Locations en cours</a></h6>
        <h6><a [routerLink]="['/owner/rent']">Locations conclues</a></h6>
        <mat-divider></mat-divider>
        <h5>Communication</h5>
        <h6><a [routerLink]="['/owner/appointments']">Mes rendez-vous </a></h6>
        <h6><a [routerLink]="['/owner/conversations']">Mes conversations</a></h6>
        <h6><a [routerLink]="['/owner/notifications']">Notifications </a></h6>
        <mat-divider></mat-divider>
        <h5>Compte</h5>
        <h6><a [routerLink]="['/owner/my-providers']">Mes fournisseurs </a></h6>
        <h6><a [routerLink]="['/owner/contracts']">Mes contrats</a></h6>
        <h6><a [routerLink]="['/owner/account']">Mon profil</a></h6>
        <h6><a [routerLink]="['/provider']">Mon compte provider </a></h6>
        <!-- <h6><a [routerLink]="['/provider/public']" [queryParams]="{id: currentUserId}">Mon profil public </a></h6> -->
      </mat-drawer>
      <div class="sidenav-page">
        <div class="session-top">
          <h3>Menu Propriétaire &nbsp;&nbsp;&nbsp;</h3>
          <button mat-icon-button (click)="drawer.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </div>
        <div class="session-content">
          <router-outlet></router-outlet>
          @if ((fetchingResults$ | async)!) {
            <p style="text-align:center">
              <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
            </p>
          }
        </div>
      </div>
    </mat-drawer-container>
  </div>
}
